import { render, staticRenderFns } from "./add-stock.vue?vue&type=template&id=40ee39fb&scoped=true&"
import script from "./add-stock.vue?vue&type=script&lang=js&"
export * from "./add-stock.vue?vue&type=script&lang=js&"
import style0 from "./add-stock.vue?vue&type=style&index=0&id=40ee39fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ee39fb",
  null
  
)

export default component.exports